import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  style: {
    margin: "30px",
  },
}))

export default useStyles
